import insecureRoutes from './insecureRoutes'
import appsRoute from './appsRoute'

export const allRoutes = [
  ...insecureRoutes,
  ...appsRoute
]